import { forwardRef, type SVGProps } from "react";

export const EnglishFlagIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      {...props}
    >
      <title>English Flag</title>
      <path
        fill="#EEE"
        d="M503.2 322.8q8.7-32 8.8-66.8l-8.8-66.8a255 255 0 0 0-28.8-66.8l-59-66.7A255 255 0 0 0 256 0h-.2A255 255 0 0 0 96.6 55.7l-59 66.7a255 255 0 0 0-28.8 66.8L0 256v.1q0 34.6 8.8 66.7l28.8 66.8a257 257 0 0 0 59 66.7L256 512l159.4-55.7a257 257 0 0 0 59-66.7z"
      />
      <path
        fill="var(--flag-palette-bright-red, #d80027)"
        d="M503.2 189.2q8.7 32 8.8 66.8H0q0-34.7 8.8-66.8zM415.4 55.7a257 257 0 0 1 59 66.7H37.6a257 257 0 0 1 59-66.7zm59 333.9q19-31 28.8-66.8H8.8a255 255 0 0 0 28.8 66.8zm-59 66.7H96.6A255 255 0 0 0 255.8 512h.4a255 255 0 0 0 159.2-55.7"
      />
      <path
        fill="var(--flag-palette-blue, #0052b4)"
        d="M0 245.6A256 256 0 0 1 256 0v256H0z"
      />
      <path
        fill="#EEE"
        fillRule="evenodd"
        d="M109.5 46a256 256 0 0 1 26.2-16l1 3h27.8L142 49.2l8.7 26.6L128 59.5l-22.6 16.4 8.6-26.6zm-80 90.4q9-16.7 20.1-32l3.8 11.7h28l-22.7 16.4 8.7 26.6-22.6-16.4L22.2 159zm181.7-130 8.6 26.5h28L225 49.3l8.7 26.6-22.6-16.4-22.6 16.4 8.7-26.6L174.7 33h27.9zM128 89.6l8.6 26.5h28l-22.7 16.4 8.7 26.6-22.6-16.4-22.6 16.4 8.6-26.6-22.5-16.4h27.9zm91.8 26.5-8.6-26.5-8.6 26.5h-28l22.7 16.4-8.7 26.6 22.6-16.4 22.6 16.4-8.7-26.6 22.6-16.4zm-175 56.7 8.6 26.5h28l-22.7 16.4 8.7 26.6-22.6-16.4-22.6 16.4 8.7-26.6-22.6-16.4h27.9zm91.8 26.5-8.6-26.5-8.6 26.5h-28l22.6 16.4-8.6 26.6 22.6-16.4 22.6 16.4-8.7-26.6 22.6-16.4zm74.6-26.5 8.6 26.5h28L225 215.7l8.7 26.6-22.6-16.4-22.6 16.4 8.7-26.6-22.6-16.4h27.9z"
        clipRule="evenodd"
      />
    </svg>
  );
});
EnglishFlagIcon.displayName = "EnglishFlagIcon";

export const SpanishFlagIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      {...props}
    >
      <title>Spanish Flag</title>
      <g clipPath="url(#spanish-flag-clip)">
        <path
          fill="var(--flag-palette-yellow, #ffda44)"
          d="M477.8 384A255 255 0 0 0 512 256c0-46.6-12.5-90.3-34.2-128H34.2A255 255 0 0 0 0 256c0 46.6 12.5 90.3 34.2 128z"
        />
        <path
          fill="var(--flag-palette-bright-red, #d80027)"
          d="M256 512A256 256 0 0 1 25.6 368h460.6A256 256 0 0 1 256 512m0-512A256 256 0 0 0 25.7 144h460.6A256 256 0 0 0 256 0"
        />
        <path fill="#EEE" d="M144 304h-16v-80h16zm128 0h16v-80h-16z" />
        <path
          fill="var(--flag-palette-bright-red, #d80027)"
          d="M122 248a4 4 0 1 0 0 8h172a4 4 0 1 0 0-8zm0 24a4 4 0 1 0 0 8h28a4 4 0 1 0 0-8zm144 0a4 4 0 1 0 0 8h28a4 4 0 1 0 0-8z"
        />
        <path
          fill="#EEE"
          fillRule="evenodd"
          d="M196 168c-7 0-13 5-15 11l-5-1c-9 0-16 7-16 16s7 16 16 16c7 0 13-4 15-11a16 16 0 0 0 17-4 16 16 0 0 0 17 4 16 16 0 1 0 10-20 16 16 0 0 0-27-5q-4.5-6-12-6m0 8c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-8 0-4 4-8 8-8m24 0c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-8 0-4 4-8 8-8m-44 10 4 1 4 8c0 4-4 7-8 7s-8-3-8-8c0-4 4-8 8-8m64 0c5 0 8 4 8 8 0 5-3 8-8 8-4 0-8-3-8-7l4-8zm-32 142c26.5 0 48-14.3 48-32 0-9.6-6.3-18.1-16.2-24H256v-48h-48v40c-26.5 0-48 14.3-48 32s21.5 32 48 32"
          clipRule="evenodd"
        />
        <path
          fill="var(--flag-palette-gold, #ff9811)"
          d="M200 160h16v32h-16z"
        />
        <path
          fill="var(--flag-palette-bright-red, #d80027)"
          fillRule="evenodd"
          d="m248 208-8 8h-64l-8-8c0-13 18-24 40-24s40 11 40 24m-112-16a8 8 0 0 1 8 8v8a8 8 0 0 1-16 0v-8a8 8 0 0 1 8-8m144 0a8 8 0 0 1 8 8v8a8 8 0 0 1-16 0v-8a8 8 0 0 1 8-8m-72 80v24a24 24 0 0 0 48 0v-24zm0 0h-48v-48h48zm34-30a10 10 0 1 0-20 0v12a10 10 0 1 0 20 0z"
          clipRule="evenodd"
        />
        <path
          fill="var(--flag-palette-gold, #ff9811)"
          fillRule="evenodd"
          d="M128 208h16a8 8 0 0 1 0 16h-16a8 8 0 0 1 0-16m144 0h16a8 8 0 0 1 0 16h-16a8 8 0 0 1 0-16m-128 96h-16a8 8 0 0 0 0 16h16a8 8 0 0 0 0-16m128 0h16a8 8 0 0 1 0 16h-16a8 8 0 0 1 0-16m-112-32v24c0 8 4 14 9 19l5-6 5 10q5 1.2 10 0l5-10 5 6c6-5 9-11 9-19v-24h-9l-5 8-5-8h-10l-5 8-5-8zm8-32v-8h32v8h-8v16h8v8h-32v-8h8v-16zm72-24h-64v8h64z"
          clipRule="evenodd"
        />
        <path
          fill="var(--flag-palette-bright-red, #d80027)"
          d="M169 272v43q4.6 3 10 4v-47zm20 0v47q5.4-1 10-4v-43z"
        />
        <path
          fill="var(--flag-palette-yellow, #ffda44)"
          fillRule="evenodd"
          d="M186 208a6 6 0 1 0 0-12 6 6 0 0 0 0 12m22 0a6 6 0 1 0 0-12 6 6 0 0 0 0 12m28-6a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
          clipRule="evenodd"
        />
        <path
          fill="var(--flag-palette-blue, #0052b4)"
          fillRule="evenodd"
          d="M208 288a16 16 0 1 0 0-32 16 16 0 0 0 0 32m80 32h-16a8 8 0 0 0 0 16h16a8 8 0 0 0 0-16m-160 0h16a8 8 0 0 1 0 16h-16a8 8 0 0 1 0-16"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="spanish-flag-clip">
          <path fill="#fff" d="M0 0h512v512H0z" />
        </clipPath>
      </defs>
    </svg>
  );
});
SpanishFlagIcon.displayName = "SpanishFlagIcon";
